import {noop} from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './router/App';
import {getClarity} from './util/clarity/getClarity';
import {isProd} from './util/env/getEnv';

// Initialize Microsoft Clarity for user analytics
getClarity();

if (isProd()) {
  console.log = noop;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
